import { AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { Link } from '../../../../../../models/link';
import { AssetService } from '../../../../../../services/asset.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import _ from 'lodash';
import { ModalService } from '../../../../../../services/modal.service';
import { UrlWhitelist } from '../../../../../../../environments/configs/url-whitelist';
import { ModalComponent } from '../../../../../../models/modal-component';
import { LinkService } from '../../../../../../services/link.service';
import { Digi4SchoolValidationDirective } from '../../../../../../directives/digi4-school-validation.directive';

@Component({
    selector: 'page-link-modal',
    templateUrl: './link-modal.component.html',
    styleUrls: ['./link-modal.component.scss'],
    imports: [
        Digi4SchoolValidationDirective
    ],
    standalone: true
})
export class LinkModalComponent extends ModalComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() declare modalable: Link;
    imageUrl: string;
    linkText: string;
    isTrustedPlatformLink: boolean;
    iFrameURL: SafeResourceUrl;
    iFrameWidth: number;
    iFrameHeight: number;
    debouncedOnResize: (() => void) & _.Cancelable;

    constructor(
        public modalService: ModalService,
        public assetService: AssetService,
        private sanitizer: DomSanitizer,
        private linkService: LinkService) {
        super();
        this.debouncedOnResize = _.debounce(this.onResize, 100);
    }

    ngOnInit(): void {

        this.linkText = 'Link';
        if (this.modalable) {

            switch (this.modalable.type) {
                // case 5: break;
                case 3:
                    this.imageUrl = this.assetService.getUrl('link-modal/large-link-icon-video.png');
                    this.linkText = 'Video';
                    break;
                case 2:
                    this.imageUrl = this.assetService.getUrl('link-modal/large-link-icon-photo.png');
                    this.linkText = 'Foto';
                    break;
                default:
                    this.linkText = 'Link';
                    this.imageUrl = this.assetService.getUrl('link-modal/large-link-icon-weblink.png');
            }
        }

        this.linkText = `${this.linkText} aufrufen`;
        if (this.modalable && this.modalable?.overlay) {
            this.iFrameWidth = window.innerWidth * 0.9;
            this.iFrameHeight = window.innerHeight * 0.75;
            this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.modalable.url);
        }
    }

    onClick(): void {
        ($('.modal.in') as any).modal('hide');
        this.linkService.logUsage(this.modalable);
    }

    onResize(): void {
        this.iFrameWidth = window.innerWidth * 0.9;
        this.iFrameHeight = window.innerHeight * 0.75;
    }

    ngAfterViewInit(): void {
        this.modalService.addAnimation(this.modalable?.getModalId());
    }

    ngOnChanges(): void {
        this.isTrustedPlatformLink = UrlWhitelist.isOnWhiteList(this.modalable);
    }

    getId(): string {
        return this.modalable.getModalId();
    }
}
